import { createSvgIcon } from './_base';

export const PortfolioIcon = createSvgIcon(
  '0 0 24 24',
  <path
    fillRule="evenodd"
    d="M2.25 6C2.25 4.48122 3.48122 3.25 5 3.25H19C20.5188 3.25 21.75 4.48122 21.75 6V18C21.75 19.5188 20.5188 20.75 19 20.75H5C3.48122 20.75 2.25 19.5188 2.25 18V6ZM20.25 14.25V9.75H14C12.7574 9.75 11.75 10.7574 11.75 12C11.75 13.2426 12.7574 14.25 14 14.25H20.25ZM20.25 8.25H14C11.9289 8.25 10.25 9.92893 10.25 12C10.25 14.0711 11.9289 15.75 14 15.75H20.25V18C20.25 18.6904 19.6904 19.25 19 19.25H5C4.30964 19.25 3.75 18.6904 3.75 18V6C3.75 5.30964 4.30964 4.75 5 4.75H19C19.6904 4.75 20.25 5.30964 20.25 6V8.25ZM14 11.25C14.4142 11.25 14.75 11.5858 14.75 12V12.01C14.75 12.4242 14.4142 12.76 14 12.76C13.5858 12.76 13.25 12.4242 13.25 12.01V12C13.25 11.5858 13.5858 11.25 14 11.25Z"
  />
);
